import "./styles.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook, faInstagram } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import ResourceDisplay from "../../../../components/resource-display";
import { Link, useLoaderData, useRouteError } from "react-router-dom";
import GenericErrorDisplay from "../../../generic-error";
import Perfuzie from "../../../../components/perfuzie-doneaza/index.jsx";
import useWindowDimensions from "../../../../hooks/useWindowDimensions";
import GalleryService from "../../../../service/gallery";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import { externalRedirectUrl } from "../../../page-redirect";
import ButtonClipboardCopy from "../../../../components/button-clipboard-copy/index";
import ResourceService from "../../../../service/resource";
import { IMAGE_HOST } from "../../../../api/config";

const structureId = "doneaza";
export const path = structureId + "/";

const resourceKeys = {
  pageTitle: "about-projects-doneaza-title",
  pageSubtitle: "about-projects-doneaza-subtitle",
  headerDoneaza: "about-doneaza-header",
  headerDoneaza2: "about-doneaza-header-2",
  bodyText: "about-doneaza-bodyText",
  logo: "about-doneaza-logo",
  text1: "about-doneaza-text-primapunga",
  text2: "about-doneaza-text-adouapunga",
  text3: "about-doneaza-text-atreiapunga",
  blood: "about-doneaza-sange",
};

export async function loader() {
  const resourcesArray = new ResourceService().read.byIds(
    Object.values(resourceKeys),
  );
  const gallery = new GalleryService().read.byStructure(structureId);
  return [await resourcesArray, await gallery];
}

export function Component() {
  const [resources, gallery] = useLoaderData();
  const dimensions = useWindowDimensions();

  return (
    <div className="page-doneaza">
      <div className="header">
        {dimensions.width > 600 ? (
          <>
            <ResourceDisplay
              resource={resources[resourceKeys.pageTitle]}
              wrapper={dimensions.width > 1350 ? "h1" : "h3"}
              className="header-text"
            />
            <div className="header-image">
              <ResourceDisplay
                resource={resources[resourceKeys.headerDoneaza]}
                className="header-doneaza"
              />
            </div>
          </>
        ) : (
          <>
            <div className="header-image">
              <ResourceDisplay
                resource={resources[resourceKeys.headerDoneaza2]}
                className="header-doneaza"
              />
            </div>
          </>
        )}
        <div className="header-subtitle">
          <ResourceDisplay
            resource={resources[resourceKeys.pageSubtitle]}
            wrapper="h2"
          />
        </div>
      </div>
      <div className="body">
        {/* <h2 className="body-title">Despre proiect</h2> */}
        <div className="body-paragh content-container">
          <ResourceDisplay resource={resources[resourceKeys.bodyText]} />
        </div>
        <div className="perfuzii">
          <Perfuzie
            text={resources[resourceKeys.text1]}
            sange={resources[resourceKeys.blood]}
            number={1}
          />
          <Perfuzie
            text={resources[resourceKeys.text2]}
            sange={resources[resourceKeys.blood]}
            number={2}
          />
          <Perfuzie
            text={resources[resourceKeys.text3]}
            sange={resources[resourceKeys.blood]}
            number={3}
          />
        </div>
        <div className="container-fasmr">
          <div className="logo">
            <ResourceDisplay resource={resources[resourceKeys.logo]} />
          </div>
          <div className="icons">
            <Link
              to={externalRedirectUrl(
                "https://www.facebook.com/doneazasangefiierou",
              )}
            >
              <FontAwesomeIcon icon={faFacebook} />
            </Link>
            <Link
              to={externalRedirectUrl(
                "https://www.instagram.com/doneazasangefiierou.national",
              )}
            >
              <FontAwesomeIcon icon={faInstagram} />
            </Link>

            <ButtonClipboardCopy text={"doneazasange@fasmr.ro"} title="E-mail">
              <FontAwesomeIcon icon={faEnvelope} size="2xl" />
            </ButtonClipboardCopy>
          </div>
        </div>
      </div>
      <div className="images">
        <ResponsiveMasonry
          columnsCountBreakPoints={{ 300: 1, 600: 2, 900: 3, 1200: 4, 1600: 5 }}
        >
          <Masonry gutter="var(--gap-small)">
            {gallery.map((element) => (
              <img
                src={IMAGE_HOST + element.location}
                key={element.id}
                alt={element.id}
              />
            ))}
          </Masonry>
        </ResponsiveMasonry>
      </div>
    </div>
  );
}
Component.displayName = "page-about-projects-doneaza";

export function ErrorBoundary() {
  const error = useRouteError();
  return <GenericErrorDisplay error={error} />;
}
ErrorBoundary.displayName = "page-about-projects-doneaza-error";
